import { default as React, useEffect } from 'react';
import { connect } from 'react-redux';
import { AnyAction } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { AppState } from '../../types/AppState';
import { loadPathwayMetrics } from './actions';
import { draw } from './PathwayDrawer';
import { findPathway } from './reducers';
import { CohortPathway } from './types/CohortPathway';

const id = 'pathway-viewer-diagram'
const _selector = `#${id}`

interface Props {
    pathway: CohortPathway;
    selectedQueryId: number;
    loadPathwayMetrics(): void;
}

const Pathway = ({ pathway, loadPathwayMetrics }: Props) => {

    useEffect(() => {
        loadPathwayMetrics()
    }, [loadPathwayMetrics, pathway.eventConfigs.length, pathway.id])

    useEffect(() => {
        if (pathway.eventMetrics.length > 0) {
            draw({ pathway, _selector })
        }
    }, [pathway])

    return (
        <div id={id} style={{ overflow: 'auto' }} />
    )

}

const mapStateToProps = (state: AppState, ownProps: any): Props => {
    const pathway = findPathway(state.pathway.pathways, state.pathway.pathwayId!)
    return {
        pathway: pathway,
        selectedQueryId: state.current.queryId,
        ...ownProps
    }
}

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
    return {
        loadPathwayMetrics: () => {
            dispatch(loadPathwayMetrics())
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Pathway)